'use client'

import Lottie from 'lottie-react'
import React, { useEffect, useState } from 'react'

import { cn } from '@/utilities/ui'

type AnimationData = Record<string, unknown>

export function HeaderLottieLogo({
  jsonPath,
  className,
  width = 137,
  height = 85,
}: {
  jsonPath: string
  className?: string
  width?: number
  height?: number
}) {
  const [data, setData] = useState<AnimationData | null>(null)

  useEffect(() => {
    let cancelled = false
    const path = jsonPath.startsWith('/') ? jsonPath : `/${jsonPath}`

    fetch(path)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load Lottie JSON: ${res.status}`)
        return res.json()
      })
      .then((json: AnimationData) => {
        if (!cancelled) setData(json)
      })
      .catch(() => {
        if (!cancelled) setData(null)
      })

    return () => {
      cancelled = true
    }
  }, [jsonPath])

  if (!data) {
    return (
      <div
        className={cn('shrink-0 bg-muted/30', className)}
        style={{ width, height }}
        aria-hidden
      />
    )
  }

  return (
    // height: auto lets the lottie render at its natural aspect-ratio height for the given width
    <div className={cn('shrink-0', className)} style={{ width }}>
      <Lottie animationData={data} loop style={{ width: '100%', height: 'auto' }} />
    </div>
  )
}
